"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.authTokenReducer = void 0;
var getAuthToken_1 = require("./actions/getAuthToken");
var setAuthToken_1 = require("./actions/setAuthToken");
var __1 = require("..");
var api_1 = require("../../api");
var initialState = {};
var authTokenReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case getAuthToken_1.GET_AUTH_TOKEN.SUCCESS:
            return __assign(__assign({}, state), { token: action.response.id_token });
        case setAuthToken_1.SET_AUTH_TOKEN.ACTION:
            return __assign(__assign({}, state), { token: action.token });
        case __1.LOGOUT.ACTION:
            api_1.Environment.clearAuthToken();
            return initialState;
        default:
            return state;
    }
};
exports.authTokenReducer = authTokenReducer;
//# sourceMappingURL=authToken.reducer.js.map